import { t } from 'i18next';
import { FileLoader } from '@ckeditor/ckeditor5-upload';

import { MAX_FILE_SIZE } from '@bandido/shared/constants';

import { client } from '../services';

type ToastFn = (message: string) => void;

export class UploadAdapter {
  constructor(
    private loader: FileLoader,
    private showToast: ToastFn,
  ) {
    this.loader = loader;
    this.showToast = showToast;
  }

  async upload(): Promise<{ default: string }> {
    return this.loader.file.then((file: File | null) => {
      if (!file) {
        const errorMessage = t('noteEditor.errors.fileNotAvailable');
        this.showToast(errorMessage);
        return Promise.reject();
      }

      if (file.size > MAX_FILE_SIZE) {
        const errorMessage = t('noteEditor.errors.fileTooLarge');
        this.showToast(errorMessage);
        return Promise.reject();
      }

      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);
        client
          .post('/files/mails', formData)
          .then((response) => {
            resolve({
              default: response.data.url,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    });
  }
}
